import React, {useEffect, useState} from "react";
import {Container} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import Subscription from "../libs/Subscription";
import {useDispatch, useSelector} from "react-redux";
import {selectActiveCompanyId, selectUser} from "../../store/reducers/userCompany";
import {stopLoading} from "../../store/actions/loading";

function Payment() {
    const dispatch = useDispatch();
    const [paymentId, setPaymentId] = useState("");
    const [paymentMessage, setPaymentMessage] = useState("");
    const [paymentSubMessage, setPaymentSubMessage] = useState("");
    let companyId = useSelector(selectActiveCompanyId);
    const {t} = useTranslation();
    const user = useSelector(selectUser) || {};
    const userCompanyId = useSelector((state) => state?.reseller?.reseller.user?.companies[0].id);
    const resellerUserId = useSelector((state) => state?.reseller?.reseller?.user?.id);

    if (user?.userType === "reseller") {
        companyId= userCompanyId
    }

    useEffect(() => {
        if (companyId) {
            Subscription.getPayment(companyId)
                .then((res) => {
                    setPaymentId(res.payment_id);
                    dispatch(stopLoading());
                })
                .catch((error) => console.log(error));
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (paymentId && companyId)
            Subscription.checkPaymentStatus(companyId, paymentId)
                .then((res) => {
                    if (res?.paymentSuccessful === true) {
                        Subscription.updateCompanySubscription(paymentId).catch(() => {
                        });
                        setPaymentMessage(res.message);
                        setPaymentSubMessage(res.subMessage);
                        dispatch(stopLoading());
                    } else if (res.paymentSuccessful === false) {
                        setPaymentMessage(res.message);
                        dispatch(stopLoading());
                    }
                })
                .catch((error) => console.log(error));
        //eslint-disable-next-line
    }, [paymentId]);


    return (
        <Container className="full-height-container ">
            <>
                <div className="col-md-12 card o-hidden border-0 shadow-lg my-5">
                    <div className="card-body p-0">
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="py-5">
                                    <div className="d-flex justify-content-center text-center">
                                        <h1>{paymentMessage ? paymentMessage : <>{t('Loading')}...</>} </h1>
                                    </div>
                                    <div className="d-flex justify-content-center text-center">
                                        {paymentSubMessage && <p>{paymentSubMessage}</p>}
                                    </div>
                                    {user?.userType === "reseller" ?
                                        <div className="d-flex justify-content-center mt-3">
                                            <Link to={`/reseller/user-details/${resellerUserId}`}>
                                                <button className="btn btn-primary">
                                                    {t("Go to User Details page")}
                                                </button>
                                            </Link>
                                        </div> :
                                        <>{paymentMessage &&  <div className="d-flex justify-content-center mt-3">
                                            <Link to="/company-subscription">
                                                <button className="btn btn-primary">
                                                    {t("Go to subscription page")}
                                                </button>
                                            </Link>
                                        </div> }</>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </Container>
    );
}

export default Payment;
